import { AuthGuard } from '@/auth/auth-guards';
import type { RouteLocation, RouteRecordRaw } from 'vue-router';
import { getRoute, RoutePaths } from '@/views/gallery/route-paths';
import { inventoryMessages } from '@/views/inventory/inventory-messages';
import { Permission } from '@art-basel/artbasel-lib-platform';
import { backOfficeMessages } from '@/views/gallery/back-office-messages';

export const inventoryRoutes: Array<RouteRecordRaw> = [
  {
    meta: { title: inventoryMessages.inventoryTitleSeller },
    path: RoutePaths.INVENTORY,
    component: () => import('./inventory-page/InventoryPage.vue'),
    beforeEnter: (to: RouteLocation) => AuthGuard(to),
  },
  {
    meta: { title: inventoryMessages.inventoryCreateTitle },
    path: RoutePaths.INVENTORY_CREATE,
    component: () => import('./create/CreateItem.vue'),
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.CREATE_INVENTORY_ITEM),
  },
  {
    meta: { title: inventoryMessages.inventoryDetailTitle },
    path: RoutePaths.INVENTORY_DETAIL,
    component: () => import('./detail/ItemDetail.vue'),
    beforeEnter: (to: RouteLocation) => AuthGuard(to),
  },
  {
    meta: { title: inventoryMessages.inventoryEditTitle },
    path: RoutePaths.INVENTORY_EDIT,
    component: () => import('./edit/EditItem.vue'),
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.UPDATE_INVENTORY_ITEM),
  },
  {
    meta: { title: backOfficeMessages.bulkUploadTitle },
    path: RoutePaths.BULK_UPLOAD.ROOT,
    redirect: () => getRoute(RoutePaths.BULK_UPLOAD.SELECT),
  },
  {
    meta: { title: backOfficeMessages.bulkUploadTitle },
    path: RoutePaths.BULK_UPLOAD.SELECT,
    component: () => import('./bulk-upload/BulkUploadSelect.vue'),
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.CREATE_INVENTORY_ITEM),
  },
  {
    meta: { title: backOfficeMessages.bulkUploadTitle },
    path: RoutePaths.BULK_UPLOAD.REVIEW,
    component: () => import('./bulk-upload/BulkUploadReview.vue'),
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.CREATE_INVENTORY_ITEM),
  },
];
